<atx-image
  *ngIf="image && !loadFailed; else noImage"
  class="img-fluid rounded-circle"
  [imageUrl]="image"
  [maxWidth]="imageMaxSizes.AVATAR"
  [title]="alt"
  [objectFit]="mediaObjectFit.COVER"
  [objectPosition]="mediaObjectPosition.Center"
  data-e2e="current-media"
  (imageError)="loadFail()"
>
</atx-image>

<ng-template #noImage>
  <div
    *ngIf="initialsFromFullName() as i; else defaultAvatarTemplate"
    class="initials"
    [ngClass]="sizeClass()"
  >
    <span>
      {{ i }}
    </span>
  </div>
</ng-template>

<ng-template #defaultAvatarTemplate>
  <fa-icon
    *ngIf="defaultAvatar"
    [icon]="['fas', 'circle-user']"
    class="avatar-empty h-100 w-100"
  ></fa-icon>
</ng-template>
